// extracted by mini-css-extract-plugin
module.exports = {"MbrPrtlInfo":"MemberPortalInfo_MbrPrtlInfo_LwlOR","MbrPrtlInfoLeft":"MemberPortalInfo_MbrPrtlInfoLeft_13qy-","MbrPrtlInfoRight":"MemberPortalInfo_MbrPrtlInfoRight_1LeOr"};